// Base URL of the flow's API; a relative value lives on the portal's own host.
export const DEFAULT_SFP_API_URL = '/sfp/api/v1/'

export const resolveSfpBaseUrl = (configured, origin) => {
  const value = configured || DEFAULT_SFP_API_URL
  const base = value.endsWith('/') ? value : `${value}/`
  return base.startsWith('/') ? `${origin}${base}` : base
}



// WEBPACK FOOTER //
// ./src/sfp/config.js